import Warning from "../../../../content/components/Warning";
import * as React from 'react';
export default {
  Warning,
  React
};